import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PageWithCard from '../../components/infrastructure/PageWithCard';
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch';
import {
    fetchMillDispatches,
    getMillDispatch,
} from '../../app/reducers/MillDispatch/millDispatchSlice';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import { Printer, Trash } from 'react-feather';
import { authAxiosInstance } from '../../utils/axiosConfig';
import moment from 'moment';
import SetButtons from '../../components/infrastructure/SetButtons';
import { Link } from 'react-router-dom';
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup';
import { useFormik } from 'formik';
import FormikAsyncSelect from '../../components/formik/FormikAsyncSelect';
import { fetchContacts } from '../../app/reducers/Contacts/contactsSlice';
import DangerButton from '../../components/infrastructure/Buttons/DangerButton';
import PaginationClassic from '../../components/pagination/PaginationClassic';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { deleteMillDispatch } from '../../app/api/millDispatch';

const ViewMillDispatch = () => {
    const [page, setPage] = useState(1);
    const [selectedRows, setSelectedRows] = useState([]);
    const [filters,setFilters]= useState({
        createdAtFrom: '',
        createdAtTo: '',
        vendorName: '',
    })
    const [isLoading, setIsLoading] = useState(false);
    const [selectAll, setSelectAll] = useState(false);

    const { millDispatch, loading } = useSelector(getMillDispatch);

    const dispatch = useDispatch();

    const debouncedSearch = useCallback(
        _.debounce(async (search) => {
            dispatch(
                fetchMillDispatches({
                    search: search,
                    populate: true,
                    page,
                })
            );
        }, 300),
        [millDispatch]
    );
    const cols = [
        {
            Header: 'Select',
            Cell: ({ row }) => (
                <input
                    type="checkbox"
                    checked={selectedRows.some(
                        (ele) => ele._id === row?.original?._id
                    )}
                    onChange={(e) => {
                        e.currentTarget.checked;
                        if (e.currentTarget.checked) {
                            setSelectedRows([...selectedRows, row?.original]);
                        } else {
                            const filtered = selectedRows.filter(
                                (ele) => ele._id !== row.original._id
                            );
                            setSelectedRows(filtered);
                        }
                    }}
                />
            ),
        },
        {
            Header: 'Created Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {moment(row?.original?.createdAt).format('DD-MM-YYYY')}
                    </div>
                );
            },
        },
        {
            Header: 'Mill Name',
            accessor: 'vendorName',
        },
        {
            Header: 'Grey Vendor Name',
            accessor: 'greyPoRef.vendorName',
        },
        {
            Header: 'Grey Bill No',
            Cell: ({ row }) => {
                if (row?.original?.greyItem) {
                    return (
                        <a
                            target="_blank"
                            className="underline text-indigo-500"
                            href={`https://books.zoho.in/app/${process.env.REACT_APP_ZOHO_ORGANIZATION_ID}#/inventory/items/${row.original.greyItem}`}
                        >
                            {row.original.greyPoRef.billNo}
                        </a>
                    );
                } else {
                    return <span>{`${row?.original?.greyPoRef?.billNo}`}</span>;
                }
            },
        },
        {
            Header: 'Challan No.',
            accessor: 'challanNo',
        },
        {
            Header: 'Quality',
            Cell: ({ row }) => {
                return <span>{row?.original?.quality?.name}</span>;
            },
        },
        {
            Header: 'Status',
            accessor: 'status',
        },
        {
            Header: 'Location',
            Cell: ({ row }) => {
                return <span>{row?.original?.location?.name}</span>;
            },
        },
        {
            Header: ' ',
            Cell: ({ row }) => {
                return (
                    <div className="flex gap-2">
                        <PrimaryButton
                            onClick={async (e) => {
                                e.stopPropagation();
                                const response = await authAxiosInstance.post(
                                    '/millDispatch/millDispatchPdf',
                                    row?.original
                                );
                                const printWindow = window.open('', '_blank');
                                printWindow.document.write(response.data);
                            }}
                        >
                            <Printer size={20} />
                        </PrimaryButton>
                    </div>
                );
            },
        },
        {
            Header: 'Action',
            Cell: ({ row }) => {
                return (
                    <Trash
                        color="red"
                        onClick={async (e) => {
                            await deleteMillDispatch(row.original._id);
                            const payload = {
                                populate: true,
                                page,
                            };
                            if (formik?.values?.createdAtFrom) {
                                payload['createdAt']['$gte'] = moment(
                                    formik.values?.createdAtFrom
                                )
                                    .startOf('day')
                                    .valueOf();
                            }
                            if (formik?.values?.createdAtTo) {
                                payload['createdAt']['$lte'] = moment(
                                    formik.values?.createdAtTo
                                )
                                    .endOf('day')
                                    .valueOf();
                            }
                            if (formik?.values?.vendorName) {
                                payload['vendorName'] =
                                    formik.values?.vendorName;
                            }
                            dispatch(fetchMillDispatches(payload));
                        }}
                    />
                );
            },
        },
    ];
    console.log('selectedRows', selectedRows);
    const poData = useMemo(() => {
        if (millDispatch && millDispatch?.docs) return millDispatch?.docs;
        else return [];
    }, [millDispatch]);

    useEffect(() => {
        dispatch(fetchMillDispatches({ populate: true, page }));
    }, [page]);

    const formik = useFormik({
        initialValues: {
            createdAtFrom: '',
            createdAtTo: '',
            vendorName: '',
        },
        onSubmit: async (values) => {
            console.log('values', values);
            const payload = {
                populate: true,
                page,
                limit: 1000,
            };
            if (values?.createdAtFrom && !values?.createdAtTo) {
                toast.error('Require Created Date To');
                return;
            }
            if (!values?.createdAtFrom && values?.createdAtTo) {
                toast.error('Require Created Date From');
                return;
            }
            if (values?.createdAtFrom && values?.createdAtTo) {
                payload['createdAt'] = {
                    $gte: moment(values?.createdAtFrom)
                        .startOf('day')
                        .valueOf(),
                    $lte: moment(values?.createdAtTo).endOf('day').valueOf(),
                };
            }
            if (values?.vendor) {
                payload['vendor'] = values?.vendor;
            }
            await dispatch(fetchMillDispatches(payload));
        },
    });

    return (
        <div className="p-4">
            <label className="block mb-1 font-semibold">Filter By</label>
            <form
                className="flex gap-4 flex-col p-4 border mb-4"
                onSubmit={formik.handleSubmit}
            >
                <div className="flex flex-row items-center gap-4">
                    <div className="w-full">
                        <FormikAsyncSelect
                            name="vendor"
                            label="Mill Vendor"
                            formik={formik}
                            getOptions={async (value) => {
                                const action = await dispatch(
                                    fetchContacts({
                                        search: value,
                                        contact_type: 'vendor',
                                    })
                                );
                                const serverResp = action.payload.contacts.map(
                                    (ele) => ({
                                        label: `${ele.contact_name}`,
                                        value: `${ele.contact_id}/${ele.contact_name}`,
                                    })
                                );
                                return serverResp;
                            }}
                            onChange={(option) => {
                                const id = option.value.split('/')[0];
                                const vendor_name = option.value.split('/')[1];
                                formik.setFieldValue('vendorName', vendor_name);
                                formik.setFieldValue('vendor', id);
                            }}
                        />
                    </div>
                    <div className="w-full flex flex-row items-center gap-2">
                        <FormikInputDateGroup
                            formik={formik}
                            name="createdAtFrom"
                            label="Created Date From"
                        />
                        <FormikInputDateGroup
                            formik={formik}
                            name="createdAtTo"
                            label="Created Date To"
                        />
                    </div>
                </div>

                <div className="flex flex-row items-center gap-4">
                    <PrimaryButton type="submit">Filter</PrimaryButton>
                    <DangerButton
                        type="button"
                        onClick={async (e) => {
                            e.stopPropagation();
                            formik.setFieldValue('createdAtFrom', '');
                            formik.setFieldValue('createdAtTo', '');
                            formik.setFieldValue('vendorName', '');
                            formik.setFieldValue('vendor', '');

                            await dispatch(
                                fetchMillDispatches({ populate: true, page })
                            );
                        }}
                    >
                        Clear
                    </DangerButton>
                </div>
            </form>
            <TableWithHeadingAndGlobalSearch
                columns={cols}
                data={poData}
                searchFunction={debouncedSearch}
                loading={loading}
                heading={
                    <div className="flex flex-row items-center gap-4">
                        <h2 className="font-semibold text-slate-800">
                            View Mill Dispatch
                        </h2>
                        {isLoading ? (
                            <ClipLoader />
                        ) : (
                            selectedRows.length > 0 && (
                                <PrimaryButton
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        try {
                                            setIsLoading(true);
                                            // const multiplePrint =
                                            //     millDispatch?.docs?.filter(
                                            //         (pos) =>
                                            //             selectedRows.includes(
                                            //                 pos._id
                                            //             )
                                            //     );
                                            console.log(
                                                'multiple data',
                                                selectedRows
                                            );

                                            const response =
                                                await authAxiosInstance.post(
                                                    '/millDispatch/multipleMillDispatchPdf',
                                                    selectedRows
                                                );
                                            const printWindow = window.open(
                                                '',
                                                '_blank'
                                            );
                                            if (printWindow) {
                                                printWindow.document.write(
                                                    response.data
                                                );
                                                printWindow.document.close();
                                            } else {
                                                console.error(
                                                    'Popup blocked or failed to open.'
                                                );
                                                toast.error(
                                                    'Failed to open print window. Please allow popups.'
                                                );
                                            }
                                            setIsLoading(false);
                                        } catch (error) {
                                            console.log('error', error);
                                            toast.error('Failed to print');
                                        } finally {
                                            setIsLoading(false);
                                        }
                                    }}
                                >
                                    <Printer size={20} className="mr-2" />{' '}
                                    {`Selected (${selectedRows?.length})`}
                                </PrimaryButton>
                            )
                        )}
                        {selectedRows.length > 0 && (
                            <PrimaryButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedRows([]);
                                }}
                            >
                                Clear
                            </PrimaryButton>
                        )}
                    </div>
                }
            />
            <PaginationClassic
                paginationDetails={millDispatch}
                setPage={setPage}
            />
        </div>
    );
};

export default ViewMillDispatch;
